import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBG_Bi86W1aQ4xDOHEVuQ-z8BGthDMQG-E',
    libraries: '',
  },
});
